import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'ogcFilter',
  title: 'igo.ogcFilter',
  icon: 'filter_list'
})
@Component({
  selector: 'igo-ogc-filter-tool',
  template: require('./ogc-filter-tool.component.html'),
  styles: [require('./ogc-filter-tool.component.styl')]
})
export class OgcFilterToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/ogc-filter-tool/ogc-filter-tool.component.ts